'use client';

import {
	Button,
	Card, createListCollection, For, HStack, Input, Separator, Stack, Text,
} from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';
import { IoSearchSharp } from 'react-icons/io5';
import { LuRefreshCcw } from 'react-icons/lu';
import z from 'zod';

import { AppRoutes } from '@/constants';
import { JobSearchCheckboxFilter } from '@/modules/job/presentation/components';
import {
	benefitsOptions, companyFeatureOptions, educationOptions, featureOptions, jobFeatureOptions, recommendOptions,
	salaryRangeOptions,
} from '@/modules/job/presentation/constants';
import { NextLinkWrapper } from '@/modules/navigation';

import { Form } from '@packages/hook-form-wrapper';

const SearchBlock = ({ children, title }: PropsWithChildren<{ title: string }>) => (
	<Stack gap="2xs" p={4}>
		<Text fontSize="13px" fontWeight="bold">
			{title}
		</Text>
		{children}
	</Stack>
);

export const JobSearchFilter = () => {
	const currentSalaryCollection = createListCollection({ items: salaryRangeOptions });
	const educationCollection = createListCollection({ items: educationOptions });

	const searchFilters = [
		{ items: recommendOptions, title: 'Recommend'  },
		{ items: featureOptions, title: 'Feature'  },
		{ items: benefitsOptions, title: 'Benefits'  },
		{ items: jobFeatureOptions, title: 'Job Feature'  },
		{ items: companyFeatureOptions, title: 'Company Feature'  },
	];

	return (
		<Form.Provider onSubmit={() => {}} schema={z.object({})}>
			<Stack gap="xs">
				<Card.Root>
					<Card.Header as={HStack} justifyContent="space-between" p={4}>
						<Card.Title textStyle="bodyBold">Search Conditions</Card.Title>
						<NextLinkWrapper color="primary.100" href={AppRoutes.jobs.search} textStyle="bodySmall">
							<LuRefreshCcw />
							Change
						</NextLinkWrapper>
					</Card.Header>
					<Card.Body p={0}>
						<Stack borderTop="1px solid {colors.gray.15}" gap={0} separator={<Separator />}>
							<SearchBlock title="Job Location">
								<Stack gap={0}>
									<Form.Checkbox name="fullTime" w="100px">Full Time</Form.Checkbox>
									<Form.Checkbox name="partTime" w="100px">Contract</Form.Checkbox>
									<Form.Checkbox name="contract" w="100px">Other</Form.Checkbox>
								</Stack>
							</SearchBlock>
							<SearchBlock title="Job Occupation">
								<Stack gap={0}>
									<Form.Checkbox name="fullTime" w="100px">Full Time</Form.Checkbox>
									<Form.Checkbox name="partTime" w="100px">Contract</Form.Checkbox>
									<Form.Checkbox name="contract" w="100px">Other</Form.Checkbox>
								</Stack>
							</SearchBlock>
							<SearchBlock title="Job Industry">
								<Stack gap={0}>
									<Form.Checkbox name="fullTime" w="100px">Full Time</Form.Checkbox>
									<Form.Checkbox name="partTime" w="100px">Contract</Form.Checkbox>
									<Form.Checkbox name="contract" w="100px">Other</Form.Checkbox>
								</Stack>
							</SearchBlock>
							<SearchBlock title="Employment Status">
								<Stack gap={0}>
									<Form.Checkbox name="fullTime" w="100px">Full Time</Form.Checkbox>
									<Form.Checkbox name="partTime" w="100px">Contract</Form.Checkbox>
									<Form.Checkbox name="contract" w="100px">Other</Form.Checkbox>
								</Stack>
							</SearchBlock>
							<SearchBlock title="Annual Salary">
								<Form.SelectInput
									collection={currentSalaryCollection}
									name="currentAnnualSalary"
								/>
							</SearchBlock>
							<SearchBlock title="Education Level">
								<Form.SelectInput
									collection={educationCollection}
									name="currentEducationLevel"
								/>
							</SearchBlock>
							<SearchBlock title="Keyword">
								<Input placeholder="Keyword" />
							</SearchBlock>
						</Stack>
					</Card.Body>
				</Card.Root>
				<For each={searchFilters}>
					{filter => <JobSearchCheckboxFilter columns={1} key={filter.title} {...filter} />}
				</For>
				<Button colorPalette="secondary" mx={4}>
					<IoSearchSharp />
					Search
				</Button>
			</Stack>
		</Form.Provider>
	);
};
